// Japanese — mirrors src/i18n/local/en/common.ts
// B2B export context; polite form (ですます調) for UI, consistent
// terminology with bilingual-translations.ts (FOB / MOQ / OEM-ODM untranslated).

const common = {
  // Navigation
  "nav.home": "ホーム",
  "nav.products": "製品",
  "nav.factory": "工場",
  "nav.about": "会社情報",
  "nav.contact": "お問い合わせ",
  "nav.requestQuote": "見積依頼",
  "nav.menu": "メニュー",
  "nav.language": "言語",

  // CTAs
  "cta.requestQuote": "見積を依頼する",
  "cta.exploreCatalog": "カタログを見る",
  "cta.contactUs": "お問い合わせ",
  "cta.scheduleFactoryVisit": "工場見学を予約",
  "cta.requestSample": "サンプルを依頼",
  "cta.viewAll": "すべての製品を見る",

  // Common
  "common.tbd": "[Forwaro にて確認中]",
  "common.category": "カテゴリー",
  "common.material": "素材",
  "common.style": "スタイル",
  "common.filters": "絞り込み",
  "common.resetAll": "リセット",
  "common.details": "詳細",

  // Brand
  "brand.name": "Forwaro Furniture",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代家具",
  "whatsapp.cta": "WhatsApp でご連絡",
  "wechat.cta": "WeChat でつながる",

  // Home · Hero
  "home.hero.badge": "FORWARO · 風華國際 · 現代家具",
  "home.hero.headline.line1": "家は、",
  "home.hero.headline.line2Highlight": "すべての中心",
  "home.hero.headline.line3": "忙しい毎日のなかで。",
  "home.hero.subheadline": "Forwaro Furniture（風華國際）は Dongguan を拠点とする OEM / ODM メーカーです。家具デザインと安定した生産品質を両立させ、中東、ヨーロッパ、南北アメリカ、アジアの輸入業者にお応えします。",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "製品ライン",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "オーダー生産対応",
  "home.hero.stat3.value": "東莞",
  "home.hero.stat3.label": "民田工業区",
  "home.hero.stat4.value": "グローバル",
  "home.hero.stat4.label": "輸出パートナーシップ",
  "home.hero.scroll": "スクロール",

  // Home · Categories
  "home.categories.kicker": "製品ラインアップ",
  "home.categories.heading": "6つの製品ライン、信頼できる一つの工場",
  "home.categories.description": "ダイニングテーブル、コーヒーテーブル、コンソールテーブル、チェア、ソファ、テレビボード。Forwaro が輸出向けに製造する6つの B2B 家具ラインです。",

  // Home · About
  "home.about.kicker": "Forwaro について",
  "home.about.heading.line1": "家具のデザインと、",
  "home.about.heading.line2": "一貫した品質。",
  "home.about.philosophy.en":
    "忙しい日々のなかで、家はすべての中心。成功を収めた方々にとって、暮らしの美学は日常の追求となります。Forwaro Furniture は家具デザインの哲学と品質の一貫性を大切にし、美しさと職人技が調和する住まいをお届けします。",
  "home.about.location": "Forwaro Furniture（風華國際有限公司）は 1991 年に Taiwan で創業し、2006 年から中国本土で製造を行っています。現在は Dongguan の Shatian Town にある Min Tian Industrial Zone を拠点に操業しています。Forwaro は、誠実なものづくりと確実な納期を重んじる輸入業者とパートナーシップを築いています。",
  "home.about.highlight1.title": "OEM・ODM",
  "home.about.highlight1.body":
    "プライベートブランド生産から、設計・構造までのフルカスタムまで対応。",
  "home.about.highlight2.title": "輸出品質管理",
  "home.about.highlight2.body":
    "木工・張り込み・仕上げ・梱包の各工程で検品を実施し、長距離輸送にも配慮。",
  "home.about.highlight3.title": "天然大理石とスチール",
  "home.about.highlight3.body": "天然大理石を用いた象徴的な天板に、電気めっきのステンレススチールと鉄製ベースを組み合わせています。",
  "home.about.highlight4.title": "グローバル輸出網",
  "home.about.highlight4.body": "Dongguan を拠点に、中東、ヨーロッパ、南北アメリカ、アジアの輸入業者にお応えします。",
  "home.about.badgeLocation": "中国 · 東莞",
  "home.about.badgeZone": "民田工業区",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "カスタム & プライベートブランド",

  // Home · Featured
  "home.featured.kicker": "カタログプレビュー",
  "home.featured.heading": "Forwaro の6つの製品ラインをひと足先にご紹介",
  "home.featured.description": "実在する Forwaro の型番で、素材と寸法も確認済みです。詳細な仕様とお見積もりは、お気軽にお問い合わせください。",

  // Home · Markets
  "home.markets.kicker": "グローバル展開",
  "home.markets.heading": "当社が対応する輸出市場",
  "home.markets.description":
    "Forwaro は四大陸にわたる家具インポーター・ディストリビューター・ホスピタリティグループ・住宅プロジェクトと協業しています。",

  // Home · Process
  "home.process.heading": "お客様との進め方",
  "home.process.description":
    "最初のお問い合わせからコンテナ積込みまで — Forwaro の標準輸出フロー。",

  // Footer
  "footer.getInTouch.kicker": "お問い合わせ",
  "footer.getInTouch.heading":
    "Forwaro と共に\n家具の輸入プロジェクトを",
  "footer.getInTouch.description":
    "当社の輸出チームが、カスタム見積・サンプル手配・輸出書類一式まで一貫してサポートいたします。",
  "footer.contact.email": "メール",
  "footer.contact.phone": "電話",
  "footer.contact.fax": "FAX",
  "footer.contact.factory": "工場",
  "footer.contact.whatsappNote":
    "WhatsApp / WeChat のアカウントは Forwaro にて確認中です。",
  "footer.form.heading": "見積依頼",
  "footer.form.name": "お名前",
  "footer.form.email": "メールアドレス",
  "footer.form.company": "会社名",
  "footer.form.country": "国",
  "footer.form.countryPlaceholder": "国を選択",
  "footer.form.message": "メッセージ",
  "footer.form.messagePlaceholder":
    "ご要件・予定数量・仕向地などをお知らせください…",
  "footer.form.submit": "お問い合わせを送信",
  "footer.form.sending": "送信中…",
  "footer.form.success.heading": "送信完了",
  "footer.form.success.body": "輸出チームより 2 営業日以内にご連絡いたします。",
  "footer.form.sendAnother": "別のメッセージを送る",
  "footer.footerTagline": "Forwaro Furniture · 風華國際 · 現代傢俱。Dongguan を拠点とする OEM/ODM メーカーとして、中東、ヨーロッパ、南北アメリカ、アジアの輸入業者にお応えします。",
  "footer.col.products": "製品",
  "footer.col.company": "会社",
  "footer.col.markets": "輸出市場",
  "footer.col.regional": "地域代理店をお探しですか？",
  "footer.copyright": "無断複製・転載を禁じます。",
};

export default common;
